export class Audio {
     
    private id: number; 
    private name: string; 
    private file: string; 
    private duration: number; 
    private status: string; 
    private createdAt: Date; 
    private modifiedAt: Date;

    constructor( id: number, name: string, file: string, duration: number, status: string, createdAt: Date, modifiedAt: Date,) {
        this.id = id;
        this.name = name;
        this.file = file;
        this.duration = duration;
        this.status = status;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        
    }

    
    public Id = (): number => {
        return this.id
    }
    public Name = (): string => {
        return this.name
    }
    public File = (): string => {
        return this.file
    }
    public Duration = (): number => {
        return this.duration
    }
    public Status = (): string => {
        return this.status
    }
    public CreatedAt = (): Date => {
        return this.createdAt
    }
    public ModifiedAt = (): Date => {
        return this.modifiedAt
    }
}